var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.SkinComponent,{tag:"component",on:{"submit":_vm.submit},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})
}
var staticRenderFns = []

export { render, staticRenderFns }